import { Contents } from "@/types/types"
import {fr_FR} from "./fr_FR"
import {en_US} from "./en_US"
import {nl_NL} from "./nl_NL"

const contents: Contents = {
    fr_FR,
    en_US,
    nl_NL,
}

export default contents
